import { render, staticRenderFns } from "./SalepointsList.vue?vue&type=template&id=3de4de84&scoped=true&"
import script from "./SalepointsList.vue?vue&type=script&lang=js&"
export * from "./SalepointsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de4de84",
  null
  
)

export default component.exports